import { render, staticRenderFns } from "./offer.vue?vue&type=template&id=228c6b1f&"
import script from "./offer.vue?vue&type=script&lang=ts&"
export * from "./offer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports